<p-table
  #dt1
  [value]="nips"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. nip-a od ukupno {totalRecords}"
  [globalFilterFields]="[
    'batch',
    'request_nr',
    'product.name',
    'partner.company'
  ]"
>
  <ng-template pTemplate="caption">
    <div class="page-control flex align-items-start">
      <div class="grid w-100">
        <div class="col-4">
          <span class="p-input-icon-left w-100 mb-2">
            <i class="pi pi-search"></i>
            <input
              name="fieldName"
              ngDefaultControl
              [(ngModel)]="globalSearchField"
              pInputText
              type="text"
              class="w-100"
              (input)="dt1.filterGlobal($event.target.value, 'contains')"
              placeholder="Broj šarže, Broj zahteva, Ime proizvoda..."
            />
          </span>

          <p-columnFilter
            name="fieldName"
            ngDefaultControl
            [(ngModel)]="packageTypeSearchField"
            field="packaging_type"
            styleClass="w-100"
            matchMode="in"
            optionLabel="newproperty"
            [showMenu]="false"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template pTemplate="header">
              <div class="px-3 pt-3 p-0">
                <span class="text-bold">Izaberi tip</span>
              </div>
            </ng-template>
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [ngModel]="value"
                [options]="packageTypes"
                placeholder="Svi tipovi pakovanja"
                (onChange)="filter($event.value)"
                optionLabel="name"
              >
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    <span class="ml-1">{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>
        <div class="col-4">
          <div class="field w-100 mb-2">
            <p-calendar
              [(ngModel)]="rangeDates"
              dateFormat="dd.mm.yy"
              class="filter-calendar"
              placeholder="Rok izrade "
              selectionMode="range"
              (onSelect)="filterDateDeadline($event, 'deadline')"
              [showIcon]="true"
            ></p-calendar>
          </div>
          <div class="field w-100 mb-0">
            <p-calendar
              [(ngModel)]="rangeDatesCreatedAt"
              dateFormat="dd.mm.yy"
              class="filter-calendar"
              placeholder="Datum otvaranja "
              selectionMode="range"
              (onSelect)="filterDateCreatedAt($event, 'created_at')"
              [showIcon]="true"
            ></p-calendar>
          </div>
        </div>
        <div class="col-4">
          <button
            class="clear-btn mb-2"
            (click)="clearFilters('rangeDates')"
            pTooltip="Obriši filter"
            tooltipPosition="top"
          >
            <i class="pi pi-times m-0"></i>
          </button>
          <button
            class="clear-btn"
            (click)="clearFilters('rangeDatesCreatedAt')"
            pTooltip="Obriši filter"
            tooltipPosition="top"
          >
            <i class="pi pi-times m-0"></i>
          </button>
        </div>
      </div>

      <div *ngIf="!isUserAuthForAdd" class="btn-group">
        <a [routerLink]="['add']" class="main-btn add-new-btn mb-2"
          >Dodaj NIP <i class="pi pi-plus"></i
        ></a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-nip>
    <tr>
      <th pSortableColumn="id" style="width: 6rem">
        <div class="flex justify-content-between align-items-center">
          Šarža br
          <!-- <p-sortIcon field="label"></p-sortIcon> -->
        </div>
      </th>
      <th>
        <span> Datum otvaranja </span>
      </th>
      <th>
        <span>Klijent</span>
      </th>
      <th>
        <span>Zahtev br</span>
      </th>
      <th>
        <span>Rok za izradu</span>
        <!-- <p-calendar (onSelect)="dt1.filterGlobal($event, 'after')"></p-calendar> -->
      </th>
      <th>
        <span>Naziv proizvoda</span>
      </th>
      <th>
        <span>Trenutno stanje</span>
      </th>
      <th style="width: 8rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-nip>
    <tr>
      <td>
        {{ nip.batch }}
      </td>
      <td>
        <span>{{ nip.created_at | date : "dd.MM.yyyy" }}</span>
      </td>
      <td>
        <span>{{ nip.partner.company }}</span>
      </td>
      <td>
        <span>{{ nip.request_nr }}</span>
      </td>
      <td>
        <span>{{ nip.deadline | date : "dd.MM.yyyy" }}</span>
      </td>
      <td>
        <span>{{ nip.product.name }}</span>
      </td>
      <td>
        <ng-container *ngIf="nip.current_op && !nip.parallel_operations">
          <span>{{ nip.current_op.name }}</span>
        </ng-container>
        <ng-container *ngIf="nip.parallel_operations && !nip.complete">
          <span>Paralelne operacije</span>
        </ng-container>
        <ng-container *ngIf="nip.complete">
          <span>Završen</span>
        </ng-container>
      </td>
      <td class="text-center">
        <a
          class="second-btn small-btn mr-2"
          pTooltip="Izmeni"
          tooltipPosition="top"
          [routerLink]="['edit']"
          (click)="onEditNip(nip)"
        >
          <i class="pi pi-pencil"></i>
        </a>
        <button
          *ngIf="!isUserAuthForAdd"
          class="second-btn small-btn"
          type="button"
          pTooltip="Izbriši"
          tooltipPosition="top"
          (click)="onDeleteNip($event, nip.id)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="9">Ni jedan NIP nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
